// src/components/LoadingScreen.js
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./LoadingScreen.css"; // Optional for styling

import loader from "../images/loader.gif";

const LoadingScreen = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timeout = setTimeout(() => {
      navigate("/home");
    }, 2000); // 2-second loading

    return () => clearTimeout(timeout); // Cleanup
  }, [navigate]);

  return (
    <div className="loading-screen">
      
      {/* You can add a spinner or animation here */}
        <img src={loader} alt="Senu Logo" className="loader" />
      
    </div>
  );
};

export default LoadingScreen;
